/* eslint-disable react/prop-types */
import React from 'react'
import { 
  DISABLED_CUBE_COLOR, 
  SELECTED_CUBE_COLOR, 
  MY_PURCHASED_CUBE_COLOR,
  DISABLED_COLOR,
  SELECTED_COLOR,
  MY_PURCHASED_COLOR
} from '../../../shared/Modals/PurchaseTokenModal/purchaseTokenModal.data';

const TokenCube = ({ position, onClick }) => {
  const cellWidth = 18.20;
  const cellHeight = 27.19;

  // Determine colors based on state
  const cubeColors = position.color || (position.disabled ? DISABLED_CUBE_COLOR : SELECTED_CUBE_COLOR);
  
  // Map the top face color to its corresponding background highlight color (using alpha for the rect)
  const bgMapping = {
    [SELECTED_CUBE_COLOR.topFace]: SELECTED_COLOR,
    [DISABLED_CUBE_COLOR.topFace]: DISABLED_COLOR,
    [MY_PURCHASED_CUBE_COLOR.topFace]: MY_PURCHASED_COLOR,
  };
  const bgColor = bgMapping[cubeColors.topFace] || cubeColors.topFace;

  const topColor = cubeColors.topFace;
  const sideColor = cubeColors.rightFace;
  const edgeColor = cubeColors.leftFace;

  // Centering calculations for scale(1.0)
  // Base paths are approx 15.87 wide and 25.72 high
  const xOffset = (cellWidth - 15.87) / 2;
  const yOffset = (cellHeight - 25.72) / 2;

  return (
    <svg
      x={position.x}
      y={position.y}
      width={cellWidth}
      height={cellHeight}
      viewBox={`0 0 ${cellWidth} ${cellHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      dx={position.xAxis}
      dy={position.yAxis}
      // eslint-disable-next-line react/no-unknown-property
      dzone={position.dzone}
      data-disabled={position.disabled ? "true" : ""}
      style={{ cursor: position.disabled ? "not-allowed" : "pointer" }}
    >
      {/* Background Highlight Rectangle (Matching the image) */}
      <rect 
        x="0.5" 
        y="0.5" 
        width={cellWidth - 1} 
        height={cellHeight - 1} 
        fill={bgColor} 
        fillOpacity="0.4" 
        rx="2" 
      />

      {/* 3D Cube centered in cell */}
      <g transform={`translate(${xOffset}, ${yOffset})`}>
        {/* Bottom/Edge Piece */}
        <path d="M0.12793 23.6016L14.6366 23.7152L15.8683 25.7256L1.33973 25.7256L0.12793 23.6016Z" fill={edgeColor}/>
        {/* Side Piece */}
        <path d="M14.6259 23.7235L14.6329 0.302413L15.8718 2.36848L15.859 25.7171L14.6259 23.7235Z" fill={sideColor}/>
        {/* Top Main Piece */}
        <path d="M0.387134 0.259203L14.633 0.25915L14.6363 23.736L0.132987 23.6484L0.387134 0.259203Z" fill={topColor}/>
      </g>

      <foreignObject x="0" y="0" width={cellWidth} height={cellHeight} style={{ pointerEvents: 'none' }}>
        <div xmlns="http://www.w3.org/1999/xhtml" className="flex items-center justify-center w-full h-full">
          <span className="text-[10px] font-bold text-black opacity-80 select-none translate-y-[-1px]">
            {position?.tokenName}
          </span>
        </div>
      </foreignObject>
    </svg>
  )
}

export default TokenCube;
